import { render } from "./ImgIcon.vue?vue&type=template&id=05adad4b&scoped=true"
import script from "./ImgIcon.vue?vue&type=script&lang=js"
export * from "./ImgIcon.vue?vue&type=script&lang=js"

import "./ImgIcon.vue?vue&type=style&index=0&id=05adad4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05adad4b"]])

export default __exports__